exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#vlCardBackground{background:#242527 0 0 no-repeat padding-box;opacity:1;border-radius:20px;width:100%;overflow:hidden;color:#fff}", ""]);

// exports
